(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/system-selector/system-selector-component.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/system-selector/system-selector-component.js');
"use strict";


const MIN_SYSTEMS = 5;
const DISPLAY_COUNT = 5;
const COLUMN_SIZE = 1;
const SYSTEM_CHOOSE = 'Visa systemvarianter';
const {
  useState,
  useMemo
} = React;
const {
  getSystemLabelFromNumber,
  getSystemFromNumber
} = svs.components.sport.systems;
const {
  SystemExplanation
} = svs.components.tipsen.routePlaySpela.systemSelector;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const {
  Form,
  ControlGroup,
  Select,
  Option
} = svs.ui.reactForm;
const getSystemAriaLabel = systemNum => {
  const system = getSystemFromNumber(systemNum);
  const {
    systemType,
    numFullHedges,
    numHalfHedges
  } = system;
  const guarantyText = system.guaranty ? ", ".concat(system.guaranty, " nyckelrader.") : '.';
  return "".concat(systemType, ", ").concat(numFullHedges, ", ").concat(numHalfHedges, ", ").concat(system.rows.length, ", ").concat(numFullHedges, " hel garderingar, ").concat(numHalfHedges, " halv garderingar, ").concat(system.rows.length, " rader").concat(guarantyText);
};
const SystemSelectorComponent = _ref => {
  let {
    systems,
    system: selectedSystem,
    systemType,
    onClick,
    selectedItem
  } = _ref;
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const [showAllSystems, setShowAllSystems] = useState(false);
  const onToggleShowAllSystems = () => {
    setShowAllSystems(previousState => !previousState);
  };
  const systemsToShow = useMemo(() => {
    if (showAllSystems) {
      return systems;
    }
    const collapsedIndex = systems.indexOf(selectedSystem);
    const displayShift = Math.ceil(DISPLAY_COUNT / 2) + Math.floor(COLUMN_SIZE / 2) - collapsedIndex % COLUMN_SIZE; 
    let minIndex = Math.max(collapsedIndex + displayShift - DISPLAY_COUNT, 0);
    const maxIndex = Math.min(minIndex + DISPLAY_COUNT, systems.length);
    if (maxIndex - minIndex < DISPLAY_COUNT) {
      minIndex = Math.max(maxIndex - DISPLAY_COUNT, 0);
    }
    return systems.slice(minIndex, maxIndex);
  }, [systems, showAllSystems, selectedSystem]);
  const [firstSystems, remainingSystems] = useMemo(() => {
    const first = systemsToShow.slice(0, MIN_SYSTEMS);
    const rest = systemsToShow.slice(MIN_SYSTEMS);
    return [first, rest];
  }, [systemsToShow]);
  if (!isExtraSmall) {
    return React.createElement(React.Fragment, null, React.createElement(SystemExplanation, {
      selectedItem: selectedItem,
      selectedSystem: selectedSystem
    }), React.createElement("div", {
      className: "pg_system_selector",
      role: "radiogroup"
    }, React.createElement("div", {
      className: "pg_system_selector__btns"
    }, React.createElement("div", {
      className: "pg_system_selector__btns__initial"
    }, firstSystems.map(systemNum => React.createElement("label", {
      "aria-checked": systemNum === selectedSystem,
      "aria-label": getSystemAriaLabel(systemNum),
      className: "f-200 pg_system_selector__btns__btn",
      htmlFor: systemNum,
      key: systemNum
    }, getSystemLabelFromNumber(systemNum), React.createElement("input", {
      "aria-checked": systemNum === selectedSystem,
      checked: systemNum === selectedSystem,
      className: "sr-only",
      id: systemNum,
      name: systemNum,
      onChange: () => {
        onClick(systemType, systemNum);
      },
      type: "radio"
    })))), showAllSystems && React.createElement("div", {
      className: "pg_system_selector__btns__expandable",
      id: "expandable-systems"
    }, remainingSystems.map(systemNum => React.createElement("label", {
      "aria-checked": systemNum === selectedSystem,
      "aria-label": getSystemAriaLabel(systemNum),
      className: "f-200 pg_system_selector__btns__btn",
      htmlFor: systemNum,
      key: systemNum
    }, getSystemLabelFromNumber(systemNum), React.createElement("input", {
      "aria-checked": systemNum === selectedSystem,
      checked: systemNum === selectedSystem,
      className: "sr-only",
      id: systemNum,
      name: systemNum,
      onChange: () => {
        onClick(systemType, systemNum);
      },
      type: "radio"
    }))))), systems.length > MIN_SYSTEMS && React.createElement("div", {
      className: "pg_system_selector__show_all"
    }, React.createElement("label", {
      className: "f-300 margin-half system-selector-button f-bold pg_system_selector__btns__btn",
      htmlFor: "showAllSystems"
    }, showAllSystems ? 'Visa färre' : 'Visa alla', React.createElement("input", {
      "aria-controls": "expandable-systems",
      "aria-expanded": showAllSystems,
      className: "sr-only",
      id: "showAllSystems",
      onClick: onToggleShowAllSystems,
      type: "button"
    })))));
  }
  return React.createElement(React.Fragment, null, React.createElement(Form, {
    isVertical: true
  }, React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Select, {
    "data-testid": "system-selector",
    onChange: event => onClick(systemType, Number(event.target.value)),
    v2: true,
    value: selectedSystem || SYSTEM_CHOOSE
  }, React.createElement(Option, {
    value: ""
  }, SYSTEM_CHOOSE), systems.map(systemNum => React.createElement(Option, {
    key: systemNum,
    value: systemNum
  }, getSystemLabelFromNumber(systemNum)))))), React.createElement(SystemExplanation, {
    selectedItem: selectedItem,
    selectedSystem: selectedSystem
  }));
};
setGlobal('svs.components.tipsen.routePlaySpela.systemSelector.SystemSelectorComponent', SystemSelectorComponent);

 })(window);